import { ExpiredInvite } from '@/components/escript/landing/PreOnboardingFlowComponents';
import { ChatbotWidget } from '@/components/helpdesk/ChatbotWidget';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { Box } from '@montugroup/design-system';
import { useParams } from 'react-router-dom';
import { SubmitSection } from './SubmitSection';

/**
 * The page an expired or replaced onboarding link lands on. It shares the onboarding landing page's header card and
 * support chatbot, but not its other sections or scroll tracking, so its analytics are not counted as the landing
 * page's.
 */
export function ExpiredInviteLanding() {
  const { onBoardKey = '' } = useParams();
  const enableUmedsChatbot = useFeatureFlag('enable_umeds_chatbot');

  return (
    <Box data-testid="escriptExpiredInvitePage">
      <SubmitSection>
        <ExpiredInvite key={onBoardKey} onboardKey={onBoardKey} />
      </SubmitSection>
      {enableUmedsChatbot && <ChatbotWidget anonymous={true} />}
    </Box>
  );
}
